import { configureStore, ThunkAction, Action } from "@reduxjs/toolkit";
import { myApi } from "../api/apiConfig";
import { myredcucer } from "./reducers/reducer";
import AddTemplateSlice from "../components/templates/AddTemplate/AddTemplateSlice";
import authSlice from "./reducers/authSlice";

export const store = configureStore({
  reducer: {
    [myApi.reducerPath]: myApi.reducer,
    [myredcucer.name]: myredcucer.reducer,
    addtemplate: AddTemplateSlice,
    auth: authSlice,
  },
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware().concat(myApi.middleware),
});

export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
